import { Col, Row } from 'antd'
import { Field } from 'react-final-form'
import { Trans, useTranslation } from 'react-i18next'

import { TPlacementItem } from '../../OrganizerSettings'
import { Checkbox, Switch } from '../../../../../components'

import styles from './OrganizerPlacementItem.module.scss'

export type TOrganizerPlacementItemProps = {
  key: string
  name: string
  type: 'organization' | 'community'
  promoteSection?: string
}

export const OrganizerPlacementItem = ({
  key,
  name,
  type,
  promoteSection
}: TOrganizerPlacementItemProps) => {
  const { t } = useTranslation()
  return (
    <Field<TPlacementItem> key={key} name={name}>
      {({ input: { value, onChange } }) => (
        <Row className={styles.row} align="middle">
          <Col xs={8}>
            <Checkbox
              checked={value.active}
              onChange={(e) => {
                onChange({
                  target: {
                    value: { ...value, active: e.target.checked }
                  }
                })
              }}
              label={
                <Trans
                  t={t}
                  i18nKey={`events.organizerSettings.placementCheckbox_${type}`}
                  values={{ name: value.name }}
                  components={[<b key={0} />]}
                />
              }
            />
          </Col>

          <Col xs={8} className={styles.switch}>
            {value.active && (
              <Switch
                disabled={promoteSection === 'community' ? value.joinCommunity : value.joinEvent}
                checked={promoteSection === 'community' ? value.visibleCommunity : value.visible}
                onChange={(checked) =>
                  onChange({
                    target: {
                      value:
                        promoteSection === 'community'
                          ? { ...value, visibleCommunity: checked }
                          : { ...value, visible: checked }
                    }
                  })
                }
              />
            )}
          </Col>

          <Col xs={8} className={styles.switch}>
            {value.active && (
              <Switch
                checked={promoteSection === 'community' ? value.joinCommunity : value.joinEvent}
                onChange={(checked) =>
                  onChange({
                    target: {
                      value:
                        promoteSection === 'community'
                          ? { ...value, joinCommunity: checked, visibleCommunity: checked }
                          : { ...value, joinEvent: checked, visible: checked }
                    }
                  })
                }
              />
            )}
          </Col>
        </Row>
      )}
    </Field>
  )
}
